import { Grid, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import CustomAutocompleteComp from "../../../newComponent/AutocompleteComp";
import { useNavigate } from "react-router-dom";
import { useGetTokenOrLogout } from "../../../../utils/token";
import ClearButtonComp from "../../../newComponent/NewButtonComp/ResetButtonComp";
import SearchButton from "../../../newComponent/NewButtonComp/SearchButton";
import CustomTextFieldComp from "../../../newComponent/customTextFieldComp";
import { useDateUtils } from "../../../../utils/formatTime";

const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT;
export default function DetailedReportFilter({
  recycledData,
  setRecycleData,
  originalData,
  setSearchData,
  setLoading,

  setVisibleRowIds,

  setIsIndeterminate,
  setIsSelectAllChecked,
  setSelectedid,
  setGridKey,
}) {
  const getTokenOrLogout = useGetTokenOrLogout();
  const navigate = useNavigate();
  const { todaysDate, oneMonthAgoDate } = useDateUtils();

  const userId = localStorage.getItem("userId");
  const userRole=localStorage.getItem('userRole')
  const [enquiryFromDate, setEnquiryFromdate] = useState(null);
  const [enquiryToDate, setEnquiryTodate] = useState(null);
  const [name, setName] = useState("");
  const [branchlist, setBranchlist] = useState([]);
  const [branch, setBranch] = useState([]);
  const [nearstBranch, setNearestBranch] = useState([]);
  const [nearetstBranchlist , setNearestBranchList] =useState([])
  const [serviceList, setServiceList] = useState([]);
  const [service, setservice] = useState([]);
  const [subserviceList, setSubserviceList] = useState([]);
  const [subservicename, setSubserviceName] = useState([]);
  const [leadSourceList, setLeadSourceList] = useState([]);
  const [leadSourceName, setLeadSourceName] = useState([]);
  const [leadSourceIds, setLeadSourceIds] = useState([]);
  const [subleadSourceList, setsubLeadSourceList] = useState([]);
  const [subleadSourceName, setsubLeadSourceName] = useState([]);
  const [stagesList, setStagesList] = useState([]);
  const [staegename, setStageName] = useState([]);
  const [recycleByList, setRecycleByList] = useState([]);
  const [actionByList, setActionByList] = useState([]);
  const [actionByName, setActionByName] = useState([]);
  const [recycleByName, setRecycleByName] = useState([]);
  const [assignToList, setAssignToList] = useState([]);
  const [assignTo, setAssignTo] = useState([]);
  const [recycledReasonlist, setRecycleReasonList] = useState([]);
  const [recycleReasonName, setRecycleReasonName] = useState([]);
  const [recycledTo, setRecycledTo] = useState([]);
  const [recyclefromDate, setRecyclefromDate] = useState(oneMonthAgoDate);
  const [recycletoDate, setRecycleTodate] = useState(todaysDate);
  const [status, setStaus] = useState([]);


 useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${API_ENDPOINT}branch`);
        if (response.ok) {
          const data = await response.json();

        setNearestBranchList(data);
        } else {
          throw new Error(`Request failed with status: ${response.status}`);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);


  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${API_ENDPOINT}route/getallBranchByUserId/${userId}`);
        if (response.ok) {
          const data = await response.json();

          setBranchlist(data);
        } else {
          throw new Error(`Request failed with status: ${response.status}`);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);
  const allbranchList = [{ branch_name: "Select All" }, ...branchlist];

  const handelbranchchange = (event, value) => {
    if (value.some((option) => option.branch_name === "Select All")) {
      setBranch(branchlist);
    } else {
      setBranch(value);
    }
  };

    const allNearesbranchList = [{ branch_name: "Select All" }, ...nearetstBranchlist];
  const handelNearestbranchchange = (event, value) => {
    if (value.some((option) => option.branch_name === "Select All")) {
      setNearestBranch(nearetstBranchlist);
    } else {
      setNearestBranch(value);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${API_ENDPOINT}service`);
        if (response.ok) {
          const data = await response.json();
          setServiceList(data);
        } else {
          throw new Error(`Request failed with status: ${response.status}`);
        }
      } catch (error) {
        console.log("error fetching data", error);
      }
    };
    fetchData();
  }, []);

  const handleservicechange = (event, value) => {
    setservice(value);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${API_ENDPOINT}subservice`);
        if (response.ok) {
          const data = await response.json();
          setSubserviceList(data);
        } else {
          throw new Error(`Request failed with status: ${response.status}`);
        }
      } catch (error) {
        console.log("Error Fetching data", error);
      }
    };
    fetchData();
  }, []);

  const allsubserviceList = [{ name: "Select All" }, ...subserviceList];
  const handlesubserviceChange = (event, value) => {
    if (value.some((option) => option.name === "Select All")) {
      setSubserviceName(subserviceList);
    } else {
      setSubserviceName(value);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${API_ENDPOINT}leadsource`);
        if (response.ok) {
          const data = await response.json();
          setLeadSourceList(data);
        } else {
          throw new Error(`Request failed with status: ${response.status}`);
        }
      } catch (error) {
        console.log("Error Fetching data", error);
      }
    };
    fetchData();
  }, []);

  const allleadSourceList = [{ name: "Select All" }, ...leadSourceList];
  const handleLeadSourceChange = (event, value) => {
    if (value.some((option) => option.name === "Select All")) {
      setLeadSourceName(leadSourceList);
      const selectedIds = leadSourceList.map((i) => i.id);
      setLeadSourceIds(selectedIds);
    } else {
      const selectedIds = value.map((i) => i.id);
      setLeadSourceName(value);
      setLeadSourceIds(selectedIds);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${API_ENDPOINT}subleadsource`);
        if (response.ok) {
          const data = await response.json();
          if (leadSourceIds.length > 0) {
            const filterdSubleadSource = data.filter((i) =>
              leadSourceIds.includes(i.lead_source_type_id)
            );
            setsubLeadSourceList(filterdSubleadSource);
          } else {
            setsubLeadSourceList(data);
          }
        } else {
          throw new Error(`Request failed with status: ${response.status}`);
        }
      } catch (error) {
        console.log("Error Fetching data", error);
      }
    };
    fetchData();
  }, [leadSourceIds]);

  const allSubleadSourceList = [
    { source_type: "Select All" },
    ...subleadSourceList,
  ];
  const handleSubLeadSourceChange = (event, value) => {
    if (value.some((option) => option.source_type === "Select All")) {
      setsubLeadSourceName(subleadSourceList);
    } else {
      setsubLeadSourceName(value);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${API_ENDPOINT}stage`);
        if (response.ok) {
          const data = await response.json();
          setStagesList(data);
        } else {
          throw new Error(`Request failed with status: ${response.status}`);
        }
      } catch (error) {
        console.log("Error Fetching Data:", error);
      }
    };
    fetchData();
  }, []);

  const allStages = [{ stage_name: "Select All" }, ...stagesList];
  const handlestageChange = (event, value) => {
    if (value.some((option) => option.stage_name === "Select All")) {
      setStageName(stagesList);
    } else {
      setStageName(value);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(
          `${API_ENDPOINT}route2.0/getAllUserByUserId/${userId}`
        );
        if (response.ok) {
          const data = await response.json();
          setRecycleByList(data);
        } else {
          throw new Error(`Request failed with status: ${response.status}`);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, [userId]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(
          `${API_ENDPOINT}route2.0/getAllUserByUserId/${userId}`
        );
        if (response.ok) {
          const data = await response.json();
          setActionByList(data);
        } else {
          throw new Error(`Request failed with status: ${response.status}`);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, [userId]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(
          `${API_ENDPOINT}route2.0/getadvisors/${userId}`
        );
        if (response.ok) {
          const data = await response.json();
          setAssignToList(data);
        } else {
          throw new Error(`Request failed with status: ${response.status}`);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, []);

  const allAssigntoList = [{ first_name: "Select All" }, ...assignToList];
  const handlechangeAssignTo = (event, value) => {
    if (value.some((option) => option.first_name === "Select All")) {
      setAssignTo(assignToList);
    } else {
      setAssignTo(value);
    }
  };

  const allrecycleBy = [{ first_name: "Select All" }, ...recycleByList];
  const handlechangeRecycleBy = (event, value) => {
    if (value.some((option) => option.first_name === "Select All")) {
      setRecycleByName(recycleByList);
    } else {
      setRecycleByName(value);
    }
  };

  const handlechangeActionBy = (event, value) => {
  if (value.some((option) => option.first_name === "Select All")) {
    setActionByName(actionByList);
  } else {
    setActionByName(value);
  }
};


  // Recycle Reason
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${API_ENDPOINT}recyclereason`);
        if (response.ok) {
          const data = await response.json();
          console.log(data);
          setRecycleReasonList(data);
        } else {
          throw new Error(`Request failed with status: ${response.status}`);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  const allrecyclereasonList = [
    { recycle_reason: "Select All" },
    ...recycledReasonlist,
  ];
  const handlechangeRecyclereason = (event, value) => {
    if (value.some((option) => option.recycle_reason === "Select All")) {
      setRecycleReasonName(recycledReasonlist);
    } else {
      setRecycleReasonName(value);
    }
  };

  const handlechangeRecycleTo = (event, value) => {
    if (value.some((option) => option.first_name === "Select All")) {
      setRecycledTo(recycleByList);
    } else {
      setRecycledTo(value);
    }
  };

  const handleFromdateChange = (e) => {
    setRecyclefromDate(e.target.value);
  };

  const handleTodateChange = (e) => {
    setRecycleTodate(e.target.value);
  };

  const [statusList, setStatusList] = useState([
    { id: 1, name: "Pending", value: "pending" },
    { id: 2, name: "Accepted", value: "accepted" },
     { id: 3, name: "Cancelled", value: "cancelled" },
     { id: 4, name: "Reopened", value: "reopen" },
  ]);

  const handleStatusChange = (event, value) => {
    setStaus(value);
  };

  const handleApplyFilter = async (event) => {
    setLoading(true);

    setVisibleRowIds([]);

    setIsIndeterminate(false);
    setIsSelectAllChecked(false);
    setSelectedid([]);
    setGridKey((prev) => prev + 1);
    const token = getTokenOrLogout();
    if (!token) return;
    let headers = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json", // Make sure to keep the content type
    };
    const requestData = {
      enq_from_date: enquiryFromDate || null,
      enq_to_date: enquiryToDate || null,

      nearest_branch_id: nearstBranch.map((i) => i.id),
      branch_id: branch.map((i) => i.id),
      service_id: service.map((i) => i.id),
      sub_service_id: subservicename.map((i) => i.id),
      lead_source_id: leadSourceName.map((i) => i.id),
      sub_lead_source_id: subleadSourceName.map((i) => i.id),
     stage_id:staegename?.map((i)=>i.id),
      recycle_reason_id: recycleReasonName.map((i) => i.id),

      assign_to: assignTo.map((i) => i.user_id),
      recycle_request_by_id: recycleByName.map((i) => i.user_id),
      recycle_from_date: recyclefromDate || null,
      recycle_to_date: recycletoDate || null,
      user_id: parseInt(userId),
      status: status.map((i) => i.value),
      action_by: actionByName.map((i) => i.user_id),
    };

    try {
      const response = await fetch(
        `${API_ENDPOINT}route2.0/recycle-report-filter`,
        {
          method: "POST",
          headers,
          body: JSON.stringify(requestData),
        }
      );

      if (response.ok) {
        const result = await response.json();
        setLoading(false);

        setRecycleData(result);
        setSearchData(result);
      } else if (response.status === 404) {
        navigate("/page404");
      } else if (response.status === 401) {
        navigate("/page401");
      } else if (response.status === 403) {
        navigate("/page403");
      } else if (response.status === 440) {
        navigate("/page440");
      } else {
        navigate("/page500");
      }
    } catch {
      navigate("/page500");
    }
  };

  const handleResetFilter = () => {
    setRecyclefromDate(oneMonthAgoDate);
    setRecycleTodate(todaysDate);
    setName("");
    setBranch([]);
    setservice([]);
    setSubserviceName([]);
    setStageName([]);
    setRecycleByName([]);
    setStaus([]);
    setRecycledTo([]);
    setLeadSourceName([]);
    setsubLeadSourceName([]);
    setRecycleData(originalData);
    setSearchData(originalData);
    setRecycleReasonName([]);
    setNearestBranch([]);
    setEnquiryFromdate("");
    setEnquiryTodate("");
    setAssignTo([]);

    setVisibleRowIds([]);

    setIsIndeterminate(false);
    setIsSelectAllChecked(false);
    setSelectedid([]);
    setGridKey((prev) => prev + 1);
  };

  return (
    <>
      <Grid container spacing={2}>
        {/* <Grid item xs={12} lg={3} sm={6} md={6}>
              <Typography variant="h6">Enquiry Name</Typography>
              <TextField
                size="small"
                value={name}
                onChange={handleNamechange}
                InputProps={{
                  style: { borderRadius: "15px" },
                }}
                fullWidth
              />
            </Grid> */}

        <Grid item xs={12} lg={3} md={6} sm={6}>
          <Typography variant="h6">Nearest Branch</Typography>

          <CustomAutocompleteComp
            size="small"
            fullWidth
            value={nearstBranch}
            multiple
            onChange={handelNearestbranchchange}
            options={allNearesbranchList}
            getOptionLabel={(option) => option.branch_name}
            tooltipContent={(option) => option.branch_name}
          />
        </Grid>

        <Grid item xs={12} lg={3} md={6} sm={6}>
          <Typography variant="h6">Enquiry From Date</Typography>
          <CustomTextFieldComp
            size="normal"
            value={enquiryFromDate}
            type="date"
            onChange={(e) => setEnquiryFromdate(e.target.value)}
            InputProps={{
              style: { borderRadius: "10px" },
            }}
            fullWidth
          />
        </Grid>
        <Grid item xs={12} lg={3} md={6} sm={6}>
          <Typography variant="h6">Enquiry To Date</Typography>
          <CustomTextFieldComp
            size="normal"
            value={enquiryToDate}
            type="date"
            onChange={(e) => setEnquiryTodate(e.target.value)}
            InputProps={{
              style: { borderRadius: "10px" },
            }}
            fullWidth
          />
        </Grid>

        <Grid item xs={12} lg={3} md={6} sm={6}>
          <Typography variant="h6">Service</Typography>

          <CustomAutocompleteComp
            size="small"
            fullWidth
            value={service}
            multiple
            onChange={handleservicechange}
            options={serviceList}
            getOptionLabel={(option) => option.service_name}
            tooltipContent={(option) => option.service_name}
          />
        </Grid>

        <Grid item xs={12} lg={3} md={6} sm={6}>
          <Typography variant="h6">Sub Service</Typography>

          <CustomAutocompleteComp
            size="small"
            fullWidth
            value={subservicename}
            multiple
            onChange={handlesubserviceChange}
            options={allsubserviceList}
            getOptionLabel={(option) => option.name}
            tooltipContent={(option) => option.name}
          />
        </Grid>

        <Grid item xs={12} lg={3} md={6} sm={6}>
          <Typography variant="h6">Lead Source</Typography>

          <CustomAutocompleteComp
            size="small"
            fullWidth
            value={leadSourceName}
            multiple
            onChange={handleLeadSourceChange}
            options={allleadSourceList}
            getOptionLabel={(option) => option.name}
            tooltipContent={(option) => option.name}
          />
        </Grid>

        <Grid item xs={12} lg={3} md={6} sm={6}>
          <Typography variant="h6">Sub Lead Source</Typography>

          <CustomAutocompleteComp
            size="small"
            fullWidth
            value={subleadSourceName}
            multiple
            onChange={handleSubLeadSourceChange}
            options={allSubleadSourceList}
            getOptionLabel={(option) => option.source_type}
            tooltipContent={(option) => option.source_type}
          />
        </Grid>

        <Grid item xs={12} lg={3} md={6} sm={6}>
          <Typography variant="h6">Stages</Typography>

          <CustomAutocompleteComp
            size="small"
            fullWidth
            value={staegename}
            multiple
            onChange={handlestageChange}
            options={allStages}
            getOptionLabel={(option) => option.stage_name}
            tooltipContent={(option) => option.stage_name}
          />
        </Grid>

        {!["advisor","trainer","admin"].includes(userRole) && (

        <Grid item xs={12} lg={3} md={6} sm={6}>
          <Typography variant="h6">Branch</Typography>

          <CustomAutocompleteComp
            size="small"
            fullWidth
            value={branch}
            multiple
            onChange={handelbranchchange}
            options={allbranchList}
            getOptionLabel={(option) => option.branch_name}
            tooltipContent={(option) => option.branch_name}
          />
        </Grid>
        )}
        <Grid item xs={12} lg={3} md={6} sm={6}>
          <Typography variant="h6">Assign To</Typography>

          <CustomAutocompleteComp
            size="small"
            fullWidth
            value={assignTo}
            multiple
            onChange={handlechangeAssignTo}
            options={allAssigntoList}
            getOptionLabel={(option) =>
              `${option.first_name ? option.first_name : ""} ${
                option.last_name ? option.last_name : ""
              }`
            }
            tooltipContent={(option) =>
              `${option.first_name ? option.first_name : ""} ${
                option.last_name ? option.last_name : ""
              }`
            }
          />
        </Grid>

        <Grid item xs={12} lg={3} md={6} sm={6}>
          <Typography variant="h6">Recycle By</Typography>

          <CustomAutocompleteComp
            size="small"
            fullWidth
            value={recycleByName}
            multiple
            onChange={handlechangeRecycleBy}
            options={allrecycleBy}
            getOptionLabel={(option) =>
              `${option.first_name ? option.first_name : ""} ${
                option.last_name ? option.last_name : ""
              }`
            }
            tooltipContent={(option) =>
              `${option.first_name ? option.first_name : ""} ${
                option.last_name ? option.last_name : ""
              }`
            }
          />
        </Grid>

        <Grid item xs={12} lg={3} md={6} sm={6}>
          <Typography variant="h6">Recycle Reasons</Typography>

          <CustomAutocompleteComp
            size="small"
            fullWidth
            value={recycleReasonName}
            multiple
            onChange={handlechangeRecyclereason}
            options={allrecyclereasonList}
            getOptionLabel={(option) => option.recycle_reason}
            tooltipContent={(option) => option.recycle_reason}
          />
        </Grid>

        <Grid item xs={12} lg={3} md={6} sm={6}>
          <Typography variant="h6">Request From Date</Typography>
          <CustomTextFieldComp
            size="normal"
            value={recyclefromDate}
            type="date"
            onChange={handleFromdateChange}
            InputProps={{
              style: { borderRadius: "10px" },
            }}
            fullWidth
          />
        </Grid>
        <Grid item xs={12} lg={3} md={6} sm={6}>
          <Typography variant="h6">Request To Date</Typography>
          <CustomTextFieldComp
            size="normal"
            value={recycletoDate}
            type="date"
            onChange={handleTodateChange}
            InputProps={{
              style: { borderRadius: "10px" },
            }}
            fullWidth
          />
        </Grid>

        <Grid item xs={12} lg={3} md={6} sm={6}>
          <Typography variant="h6">Status</Typography>

          <CustomAutocompleteComp
            size="small"
            fullWidth
            value={status}
            multiple
            onChange={handleStatusChange}
            options={statusList}
            getOptionLabel={(option) => option.name}
            tooltipContent={(option) => option.name}
          />
        </Grid>

          <Grid item xs={12} lg={3} md={6} sm={6}>
  <Typography variant="h6">Action By</Typography>

  <CustomAutocompleteComp
    size="small"
    fullWidth
    value={actionByName}
    multiple
    onChange={handlechangeActionBy}
    options={allrecycleBy} // or actionByList if different
    getOptionLabel={(option) =>
      `${option.first_name || ""} ${option.last_name || ""}`
    }
    tooltipContent={(option) =>
      `${option.first_name || ""} ${option.last_name || ""}`
    }
  />
</Grid>

        <Grid
          item
          xs={12}
          lg={12}
          md={12}
          sm={12}
          textAlign="end"
          container
          justifyContent="end"
          gap={1}
        >
          <SearchButton showIcon={true} onClick={handleApplyFilter} />

          <ClearButtonComp onClick={handleResetFilter} />
        </Grid>
      </Grid>
    </>
  );
}
